import { Component } from '@angular/core';
import { ListConductivityprofiles } from 'src/app/models/conductivityprofiles.model';
import { Plant } from 'src/app/models/plant.model';
import { Train } from 'src/app/models/train.model';
import { ConductivityprofilesService } from 'src/app/services/conductivityprofiles/conductivityprofiles.service';
import { PlantsService } from 'src/app/services/plants/plants.service';
import { TrainService } from 'src/app/services/trains/trains.service';

@Component({
  selector: 'app-graph-train-selector',
  templateUrl: './graph-train-selector.component.html',
  styleUrls: ['./graph-train-selector.component.scss'],
})
export class GraphTrainSelectorComponent {
  constructor(
    private trainService: TrainService,
    private plantService: PlantsService,
    private conductivityprofilesservice: ConductivityprofilesService
  ) {}

  GotTheData = true;
  dtoptions: DataTables.Settings = {};
  plants: Plant[] = [];
  trains: Train[] = [];
  ListConductivityprofiles: ListConductivityprofiles[] = [];
  PlantId: string;
  trainId: string;
  plantDetails: Plant = new Plant();
  trainDetails: Train = new Train();

  getSelectedId(e) {
    this.PlantId = e.target.value;
    this.plantService.getPlant(this.PlantId).subscribe({
      next: (response) => {
        this.plantDetails = response;
        console.log(this.plantDetails);
      },
    });

    this.trainService.getTrainByPlantId(this.PlantId).subscribe(
      (response: Train[]) => {
        this.trains = response;
      },
      (error: any) => {
        console.log('error list');
      }
    );
  }

  getSelectedTrainId(e) {
    this.trainId = e.target.value;
    this.ListConductivityprofiles.length = 0;
    this.trainService.getTrainById(this.trainId).subscribe({
      next: (response) => {
        this.trainDetails = response;
        this.GotTheData=false;
        console.log(this.trainDetails);
      },
    });
  }

  ngOnInit(): void {
    this.dtoptions = {
      pagingType: 'full_numbers',
      order: [[0, 'desc']],
    };
    this.plantService.getAllPlant().subscribe({
      next: (plants) => {
        this.plants = plants;
      },
      error: (response) => {
        console.log(response);
      },
    });
  }
}
